import React from "react";
import axios from "axios";
import { axiosHeadersConfig, clearToken } from "./../../common/functions";

import URL from "../../common/variables";

const Logout = () => {
  axios
    .post(`${URL}/rest-auth/logout/`, {}, axiosHeadersConfig())
    .then(() => {
      clearToken();

      window.location.href = "/";
    })
    .catch((err) => console.error(err));

  return <div>Logging out...</div>;
};

export default Logout;
